import React, { useState } from "react";
import { Tooltip } from "antd";
import { IconSetting } from "../Layout/Icons";
import useChecked from "../../hooks/useChecked";
import { useMemo } from "react";
import { BlockSquare } from "../common/StyledComponents";
import { AiOutlineClose } from "react-icons/ai";
import { useDispatch } from "react-redux";
import useDebounce from "../../hooks/useDebounce";
import { putImumProduct } from "../../redux/Actions/imum_action";

const ImumProductTagPopoverShow = ({
  product_id,
  imum_product_tags,
  tag_ids = [],
  openManager,
}) => {
  const dispatch = useDispatch();

  // existing component
  const [search, setSearch] = useState("");
  const { onChangeChecked, checkedIncluded, setChecked, checked } =
    useChecked(tag_ids);

  useDebounce(
    () => {
      removeTags();
    },
    600,
    [checked.length]
  );

  console.log({ tag_ids, checked });

  const values = useMemo(() => {
    return imum_product_tags.filter(
      (d) => d.label?.toLowerCase()?.indexOf(search.toLowerCase()) !== -1
    );
  }, [search]);

  const removeTags = () => {
    console.log("removeTags");
    console.log({ checked });
    dispatch(
      putImumProduct({
        id: product_id,
        tag_ids: checked,
      })
    );
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between px-2 bg-silver">
        <input
          className="py-1 text-xs"
          style={{
            border: "none",
            backgroundColor: "transparent",
            width: "70%",
          }}
          type="text"
          placeholder="Search tag..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
        <Tooltip placement="top" title="Manage tags" className="cursor-pointer">
          <IconSetting
            onClick={() => {
              openManager();
            }}
          />
        </Tooltip>
      </div>
      {values?.length == 0 ? (
        <div className="px-2 py-1">
          <p className="mb-0">The list is empty...</p>
        </div>
      ) : (
        values.map((d) => (
          <div
            key={d.value}
            className="d-flex align-items-center cursor-pointer px-2 py-1"
            onClick={() => onChangeChecked(d.value)}
          >
            <BlockSquare color={d.color} />
            <div
              className={`ml-1 text-xs ${
                checkedIncluded(d.value) ? "text-bold" : ""
              }`}
              style={{
                color: "#737373",
              }}
            >
              {d.label}
            </div>
          </div>
        ))
      )}
      {checked.length > 0 && (
        <div
          className="px-2 py-1 bg-silver text-xs cursor-pointer"
          style={{
            color: "#4E4E4E",
          }}
          onClick={() => {
            setChecked([]);
          }}
        >
          <AiOutlineClose className="cursor-pointer mr-1" color="#4E4E4E" />
          Clear {checked.length == 1 ? "tag" : "tags"}
        </div>
      )}
    </div>
  );
};

export default ImumProductTagPopoverShow;
